import React, { useEffect } from "react";
import { Reveal } from "../../Components/Reveal/Reveal";
import { Helmet } from "react-helmet-async";
export const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms & Conditions - DataDept</title>
        <meta
          name="description"
          content="Reach out to DataDept for custom software development and IT consulting. Contact us today to discuss your project needs and discover how we can drive your business forward."
        />
        <link rel="canonical" href="/terms-conditions" />
      </Helmet>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper">
          <div className="header-into-about-section">
            <Reveal delay={0.1}>
              <span className="light-tag">Terms & Conditions</span>
            </Reveal>
            <Reveal delay={0.2}>
              <h1 className="header-tag-about">
                Terms and Conditions for DataDept
              </h1>
            </Reveal>
            <Reveal delay={0.2}>
              <h2 className="sub-header-tag-about">
                This document outlines the rules and guidelines for using our
                website and services, ensuring a secure and respectful
                environment for all users. By accessing DataDept, you agree to
                these terms, effective as of March 25, 2024.
              </h2>{" "}
            </Reveal>
          </div>
        </div>
      </section>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper term-rules-privacy-style">
          <h1>Terms and Conditions for DataDept</h1>
          <p>
            <strong>Effective Date: March 25, 2024</strong>
          </p>
          <p>
            Welcome to DataDept! By accessing our website and using our
            services, you agree to be bound by the following terms and
            conditions. Please read them carefully.
          </p>

          <h2>1. Use of Service</h2>
          <p>
            DataDept provides software development services. The use of our
            services is subject to the terms and conditions contained herein and
            all applicable laws and regulations. By accessing and using our
            services, you accept and agree to these terms without any limitation
            or qualification.
          </p>

          <h2>2. Intellectual Property Rights</h2>
          <p>
            All content on our website, including but not limited to text,
            graphics, logos, and software, is the property of DataDept or its
            content suppliers and protected by copyright and intellectual
            property laws. You agree not to reproduce, duplicate, copy, sell,
            resell, or exploit any portion of the service, use of the service,
            or access to the service without express written permission from us.
          </p>

          <h2>3. User Obligations</h2>
          <p>
            You agree to use our website and services only for lawful purposes
            and in a way that does not infringe the rights of, restrict, or
            inhibit anyone else's use and enjoyment of the website. Prohibited
            behavior includes harassing or causing distress or inconvenience to
            any other user, transmitting obscene or offensive content, or
            disrupting the normal flow of dialogue within our website.
          </p>

          <h2>4. Termination</h2>
          <p>
            We may terminate or suspend access to our service immediately,
            without prior notice or liability, for any reason whatsoever,
            including, without limitation, if you breach the Terms and
            Conditions.
          </p>

          <h2>5. Changes to Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material, we will try to
            provide at least 30 days' notice prior to any new terms taking
            effect. What constitutes a material change will be determined at our
            sole discretion.
          </p>

          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at{" "}
            <a href="mailto:datadept.ca@gmail.com">datadept.ca@gmail.com</a>
          </p>
        </div>
      </section>
    </>
  );
};
